import React from 'react';

import AdminLayout from '../../../components/Layout/AdminLayout';

import messages from '../../../locale/jsonMessages';
import AddReportType from './AddReportType';

export default async function action({ store, intl }) {

    const title = intl?.formatMessage(messages.reportTypeManagement);

    let isAdminAuthenticated;

    isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    return {
        title,
        component: <AdminLayout><AddReportType title={title} /></AdminLayout>,
    };
}
